// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","587":"component---src-templates-dsg-tsx"}[chunkId] || chunkId) + "-" + {"218":"102d4d39e4858cf1c3af","587":"0257120d1cb9990a71de","731":"c00b17972ab5c36ef560","843":"27fbf513fff918ceb8b2"}[chunkId] + ".js";
};